export enum SvgIcons {
  'account-cancel',
  'account-edit',
  'account-minus',
  'account-multiple',
  'account-plus',
  'add-location',
  'add-photo-alternate',
  'apps',
  'arrow-left',
  'attachment',
  'ballot',
  'bell',
  'calendar-check',
  'calendar-remove',
  'camera',
  'card-multiple',
  'circle-info-solid',
  'chart-pie',
  'check-all',
  'check-circle',
  'check',
  'chevron-double-left',
  'chevron-double-right',
  'chevron-down',
  'chevron-left',
  'chevron-right',
  'chevron-up',
  'circle',
  'clipboard-check',
  'clipboard-clock',
  'clipboard-list',
  'clipboard-text',
  'close-circle',
  'close',
  'closed-caption',
  'cloud-download',
  'cloud-upload',
  'cog',
  'crop-square',
  'cube',
  'delete-forever',
  'dots-circle',
  'dots-horizontal',
  'download',
  'drag-indicator',
  'drive-file-rename',
  'email',
  'error',
  'exclamation-thick',
  'file-document',
  'file-excel',
  'file-export',
  'file-pdf-box',
  'file-png-box',
  'file-word',
  'file',
  'filter',
  'floppy-disk-solid',
  'folder-zip',
  'format-list-checkbox',
  'format-list-numbered',
  'history',
  'hourglass-full',
  'inbox',
  'key',
  'layers-triple',
  'lifebuoy',
  'location-off',
  'location-on',
  'lock-open-variant',
  'lock-open',
  'lock',
  'logout',
  'loop',
  'magnify',
  'map-marker-plus',
  'map-marker',
  'map',
  'menu-down',
  'menu-right',
  'menu',
  'message',
  'message-text',
  'minus-circle',
  'multiplication',
  'newspaper-variant',
  'playlist-plus',
  'plus',
  'package-variant',
  'question-answer',
  'refresh',
  'report',
  'send',
  'swap-horizontal',
  'shield-account',
  'shield-key',
  'text-snippet',
  'tune',
  'vector-square',
  'view-day',
  'view-list-outline',
  'warning',
  'zoom-in',
  'zoom-out'
}
